import React from "react";
import icon1 from "../../common/images/crm-ico-1.png"
import icon2 from "../../common/images/crm-ico-2.png"
import icon3 from "../../common/images/crm-ico-3.png"
import icon4 from "../../common/images/crm-ico-4.png"
import icon5 from "../../common/images/crm-ico-5.png"
import icon6 from "../../common/images/crm-ico-6.png"
import downImg from "../../common/images/crm-line.png"

const features = [
  {
    img: icon6,
    title: "Centralized Customer Data",
    description:
      "Store and manage customer profiles, purchase history, and communication records in one place for easy access and better customer service.",
  },
  {
    img: icon1,
    title: "Sales Automation",
    description:
      "Automate follow-ups, lead tracking, and sales pipeline management to close deals faster and improve sales efficiency.",
  },
  {
    img: icon5,
    title: "Task and Workflow Automation",
    description:
      "Reduce manual work with automated workflows for customer onboarding, order processing, and service requests.",
  },
  {
    img: icon2,
    title: "Custom Reporting & Analytics",
    description:
      "Generate detailed reports and dashboards to analyze customer behavior, sales performance, and business trends.",
  },
  {
    img: icon3,
    title: "Lead and Opportunity Management",
    description:
      "Track leads through the sales funnel, assign them to teams, and monitor progress in real-time.",
  },
  {
    img: icon4,
    title: "Integration with Third-Party Platforms",
    description:
      "Seamlessly integrate with existing systems such as accounting software, email platforms, and payment gateways.",
  },
];

const Section_one = () => {
  return (
      <div
        className="relative bg-secondary  bg-cover bg-center bg-no-repeat text-white md:py-7 py-5 "
        style={{ backgroundImage: "url('/android-dot.png')" }}
      >
        {/* Main Heading */}
        <div className="max-w-[1280px] mx-auto text-center px-5 md:px-10 md:pt-7 md:pb-5 pt-0 pb-0">
          <h2 className="small:text-3xl text-2xl small:overflow-hidden small:whitespace-nowrap  small:animate-typing font-bold md:text-4xl ">
          Key Features   </h2>{" "}
          <div className="underline small:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-primary">
            <p className="h-[5px] rounded-xl bg-primary w-[50%]"></p>
          </div>
        </div>

        {/* Image Below Paragraph */}
        <section className=" text-white md:px-10 px-5 py-5 ">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="text-center space-y-4">
            <div className="flex justify-center">
              <img
                src={feature.img}
                alt={feature.title}
                className="size-[111px] object-contain"
              />
            </div>
            <h3 className="text-lg font-semibold small:h-16">{feature.title}</h3>
            <p className="text-sm text-gray-300">{feature.description}</p>
          </div>
        ))}
      </div>
      <img src={downImg} className="pt-5" alt="" srcset="" />
    </section>
    
      </div>

  );
};

export default Section_one;
